import HolidayWork from 'features/rvd';
import { useTitle } from '../helpers';

/**
 * @page Absence page
 */
const HolidayWorkPage = () => {
  useTitle('РВД');

  return (
    <div>
      <HolidayWork />
    </div>
  );
};

export default HolidayWorkPage;
